var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.imageBoxStyle},[_c('div',{class:_vm.imageTitleStyle},[_vm._v(" "+_vm._s(_vm.imageTitle)+" ")]),_c('div',[_c('b-image',{attrs:{"src":_vm.getImagePath,"ratio":"1by1"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }